import {useSetAtom} from "jotai";
import {Farm, PostFarmBody} from "../types/domain/farm";
import {useFetchItems} from "./useFetchItems";
import {useResourceManagement} from "./resourceHooks";
import {createFarm, deleteFarm, editFarm, getAllFarms} from "../services/farmService";
import {useLoadableValueOrDefault} from "./jotaiHooks";
import {activeCompanyFarmsAtom, activeCompanyFarmsLoadable} from "../store/activeCompanyFarmsStore";

export const useFarms = (companyId: string | null) => {
    //  TODO make useFetch more universal, by using something like
    //  const cb = useCallback(()=>{ getAllFarms(companyId), [companyId, getAllFarms]}
    // useFetchItems(cb)
    return useFetchItems<Farm>(companyId, getAllFarms);
};

export const useActiveCompanyFarms = () => {
    const refresh = useSetAtom(activeCompanyFarmsAtom);
    const items = useLoadableValueOrDefault(activeCompanyFarmsLoadable, [], (atom) => atom.farms);
    const mapByFarmId = useLoadableValueOrDefault(activeCompanyFarmsLoadable, {}, (atom) => atom.mapByFarmId);

    return {items, mapByFarmId, refresh};
};

export const useFarmManagement = () =>
    useResourceManagement({
        getAll: (companyId: string) => getAllFarms(companyId),
        create: (companyId: string, props: PostFarmBody) => createFarm(companyId, props),
        edit: (companyId: string, id: string, props: PostFarmBody) => editFarm(companyId, id, props),
        delete: (companyId: string, id: string) => deleteFarm(companyId, id),
    });
